// 16×16 pixel art sprites — Monument Valley architectural icons
// ─────────────────────────────────────────────────────────────
// Palette (exported as MV_PALETTE, passed via PixelSprite palette prop):
//   0 = transparent
//   1 = #c09840  warm gold   (outlines, highlights, steps)
//   2 = #2a1840  deep stone  (shadows, dark fills)
//   3 = #5ab4ac  dusty teal  (windows, accents)
//   4 = #f0e0c8  warm cream  (lit faces)
//   5 = #c05848  dusty rose  (hot accents)
//   6 = #7060a0  soft purple (mid-tone stone)

export const MV_PALETTE = {
  0: 'none',
  1: '#c09840',
  2: '#2a1840',
  3: '#5ab4ac',
  4: '#f0e0c8',
  5: '#c05848',
  6: '#7060a0',
};

// ── Personal Site — Stepped Obelisk Tower ─────────────────────────────────────
// Front-facing stepped tower inspired by MV's impossible architecture
export const MONITOR = [
  [0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,1,4,1,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,1,4,1,0,0,0,0,0,0,0],
  [0,0,0,0,0,1,4,4,4,1,0,0,0,0,0,0],
  [0,0,0,0,0,1,4,3,4,1,0,0,0,0,0,0],
  [0,0,0,0,0,1,4,4,4,1,0,0,0,0,0,0],
  [0,0,0,0,1,4,4,4,4,4,1,0,0,0,0,0],
  [0,0,0,0,1,4,2,2,2,4,1,0,0,0,0,0],
  [0,0,0,0,1,4,4,4,4,4,1,0,0,0,0,0],
  [0,0,0,1,4,4,4,4,4,4,4,1,0,0,0,0],
  [0,0,0,1,4,2,2,2,2,2,4,1,0,0,0,0],
  [0,0,0,1,4,4,4,4,4,4,4,1,0,0,0,0],
  [0,0,1,4,4,4,4,4,4,4,4,4,1,0,0,0],
  [0,0,1,1,1,1,1,1,1,1,1,1,1,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];

// ── Geronimo API Explorer — Eye of the Valley ─────────────────────────────────
// Concentric diamond "eye" — MV's impossible optical geometry
export const EXPLORER = [
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0],
  [0,0,0,0,1,1,4,4,4,1,1,0,0,0,0,0],
  [0,0,0,1,4,4,4,3,4,4,4,1,0,0,0,0],
  [0,0,1,4,4,3,3,4,3,3,4,4,1,0,0,0],
  [0,0,1,4,3,3,5,5,5,3,3,4,1,0,0,0],
  [0,0,1,4,3,5,5,4,5,5,3,4,1,0,0,0],
  [0,0,1,4,3,3,5,5,5,3,3,4,1,0,0,0],
  [0,0,1,4,4,3,3,4,3,3,4,4,1,0,0,0],
  [0,0,0,1,4,4,4,3,4,4,4,1,0,0,0,0],
  [0,0,0,0,1,1,4,4,4,1,1,0,0,0,0,0],
  [0,0,0,0,0,0,1,1,1,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];

// ── Movie Search UI — Geometric Portal / Screen ────────────────────────────────
// Framed rectangular portal with an inner teal diamond (MV's gateway motif)
export const CLAPPER = [
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0],
  [0,0,1,4,4,4,4,4,4,4,4,4,4,1,0,0],
  [0,0,1,4,1,1,4,4,4,4,1,1,4,1,0,0],
  [0,0,1,4,1,4,4,4,4,4,4,1,4,1,0,0],
  [0,0,1,4,4,4,4,3,3,4,4,4,4,1,0,0],
  [0,0,1,4,4,4,3,4,4,3,4,4,4,1,0,0],
  [0,0,1,4,4,4,3,4,4,3,4,4,4,1,0,0],
  [0,0,1,4,4,4,4,3,3,4,4,4,4,1,0,0],
  [0,0,1,4,1,4,4,4,4,4,4,1,4,1,0,0],
  [0,0,1,4,1,1,4,4,4,4,1,1,4,1,0,0],
  [0,0,1,4,4,4,4,4,4,4,4,4,4,1,0,0],
  [0,0,1,1,1,1,1,1,1,1,1,1,1,1,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];

// ── Firefly Gallery UI — Faceted Gem / Crystal ─────────────────────────────────
// Descending diamond gem — crystalline MV collectible
export const FIREFLY = [
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,1,1,1,1,1,0,0,0,0,0,0],
  [0,0,0,0,1,4,4,4,4,4,1,0,0,0,0,0],
  [0,0,0,1,4,4,3,4,3,4,4,1,0,0,0,0],
  [0,0,1,4,4,4,4,4,4,4,4,4,1,0,0,0],
  [0,0,1,4,3,4,4,4,4,4,3,4,1,0,0,0],
  [0,0,0,1,4,4,4,4,4,4,4,1,0,0,0,0],
  [0,0,0,0,1,4,4,4,4,4,1,0,0,0,0,0],
  [0,0,0,0,0,1,5,4,5,1,0,0,0,0,0,0],
  [0,0,0,0,0,0,1,5,1,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];

// ── Nodecopters — Compass Rose / Sacred Mandala ────────────────────────────────
// 4-fold compass rose — MV's sacred geometry / navigation motif
export const DRONE = [
  [0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,1,4,1,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0],
  [0,0,0,1,0,0,1,4,1,0,0,1,0,0,0,0],
  [0,0,0,0,1,1,4,4,4,1,1,0,0,0,0,0],
  [0,0,0,1,1,4,3,5,3,4,1,1,0,0,0,0],
  [0,1,1,4,4,4,5,4,5,4,4,4,1,1,0,0],
  [0,1,1,4,4,4,5,4,5,4,4,4,1,1,0,0],
  [0,0,0,1,1,4,3,5,3,4,1,1,0,0,0,0],
  [0,0,0,0,1,1,4,4,4,1,1,0,0,0,0,0],
  [0,0,0,1,0,0,1,4,1,0,0,1,0,0,0,0],
  [0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,1,4,1,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0],
];
